var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yesno",class:{
    yesno_clearable: _vm.clearable,
    yesno_vertical: _vm.vertical,
  }},_vm._l((Object.entries(_vm.options || _vm.defaultOptions)),function([key, text]){return _c('span',{key:key,staticClass:"yesno__option",class:{ yesno__option_active: _vm.value == key },on:{"click":function($event){return _vm.onClick(key)}}},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }